<script setup lang="ts">
import { TooltipArrow, TooltipContent, TooltipPortal, TooltipProvider, TooltipRoot, TooltipTrigger } from 'reka-ui'
import { tooltipVariants } from '~/utils/tooltip'

type Direction = 'up' | 'down' | 'left' | 'right'

const props = withDefaults(defineProps<{
  direction?: Direction
  expandedText?: string
  collapsedText?: string
}>(), {
  direction: 'left',
  expandedText: 'Lukk',
  collapsedText: 'Åpne',
})

const isExpanded = defineModel<boolean>('expanded', {
  default: true,
})

const currentIcon = computed(() => isExpanded.value ? DIRECTION_ICONS[props.direction].expanded : DIRECTION_ICONS[props.direction].collapsed)

const tooltipText = computed(() => isExpanded.value ? props.expandedText : props.collapsedText)
</script>

<template>
  <div>
    <TooltipProvider>
      <TooltipRoot :delay-duration="200">
        <TooltipTrigger as-child>
          <div
            :class="tooltipVariants.collapse({ direction: props.direction })"
            role="button"
            tabindex="0"
            :aria-label="tooltipText"
            @click="isExpanded = !isExpanded"
            @keydown.enter="isExpanded = !isExpanded"
            @keydown.space.prevent="isExpanded = !isExpanded"
          >
            <Icon :icon="currentIcon" />
          </div>
        </TooltipTrigger>

        <TooltipPortal>
          <TooltipContent side="top" :side-offset="5" class="z-[60]">
            <TooltipArrow class="fill-white dark:fill-surface-primary w-3 h-1.5" />
            <div class="text-caption bg-white dark:bg-surface-primary shadow-sm rounded-md px-2xs py-3xs">
              {{ tooltipText }}
            </div>
          </TooltipContent>
        </TooltipPortal>
      </TooltipRoot>
    </TooltipProvider>
  </div>
</template>
